import {
  CockpitFormErrorOperation,
  CockpitFormSuccessOperation
} from '@/services/types'
import { ContactSchema } from '@/types/forms'
import { cockpitFetch } from '../client'

const postContact = async (
  payload: ContactSchema
): Promise<CockpitFormSuccessOperation | CockpitFormErrorOperation> => {
  try {
    const res = await cockpitFetch<
      CockpitFormSuccessOperation | CockpitFormErrorOperation
    >({
      method: `POST`,
      resource: `contato`,
      payload
    })

    return res.body
  } catch (error: any) {
    return error?.params?.body as CockpitFormErrorOperation
  }
}

export { postContact }
